import React from 'react';

import Avatar from '@atlaskit/avatar/Avatar';
import FeedbackIcon from '@atlaskit/icon/core/feedback';
import MentionIcon from '@atlaskit/icon/core/mention';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';

import type { ContentTypesFlagIconString } from '../services/content-types-flag-service-types.ts';

export const ContentTypesFlagIcon = ({
	iconString,
	iconColor,
	profilePicture,
}: {
	iconString: ContentTypesFlagIconString;
	iconColor: ReturnType<typeof token>;
	profilePicture?: string;
}): React.JSX.Element => {
	let IconComponent: React.ElementType;

	switch (iconString) {
		case 'feedback':
			IconComponent = FeedbackIcon;
			break;
		case 'mention':
			IconComponent = MentionIcon;
			break;
		case 'avatar':
			return profilePicture ? (
				<Avatar src={profilePicture} size="small" />
			) : (
				<MentionIcon color={token('color.icon')} label="" />
			);
		case 'info':
		default:
			IconComponent = StatusInformationIcon;
			break;
	}

	return <IconComponent color={iconColor} label="" />;
};

export const getContentTypesFlagIcon = (
	iconString: ContentTypesFlagIconString,
	iconColor?: ReturnType<typeof token>,
	profilePicture?: string,
): React.JSX.Element => (
	<ContentTypesFlagIcon
		iconString={iconString}
		iconColor={iconColor ?? token('color.icon')}
		profilePicture={profilePicture}
	/>
);
